import { Calculator } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconCalculator12Line = createIcon(Calculator, 12, "Line");
export const IconCalculator16Line = createIcon(Calculator, 16, "Line");
export const IconCalculator20Line = createIcon(Calculator, 20, "Line");
export const IconCalculator24Line = createIcon(Calculator, 24, "Line");
export const IconCalculator32Line = createIcon(Calculator, 32, "Line");
export const IconCalculator48Line = createIcon(Calculator, 48, "Line");
export const IconCalculator64Line = createIcon(Calculator, 64, "Line");
